import { useContext } from "react";
import { ImageUploadContext } from "providers/ImageUploadProvider";

export default function useImageUpload() {
  const context = useContext(ImageUploadContext);
  if (context === undefined) {
    throw new Error("useImageUpload must be used within a ImageUploadContext");
  }
  return context;
}
